<template>
  <div class="trends">
    <div class="head">
      <h3>Latest News</h3>
      <p>
        GYT has never stopped to explore the new development pattern of dialysis
        and promote the healthy and sustainable development of the kidney
        disease medical industry.
      </p>
    </div>
    <div class="content">
      <ul>
        <li
          class="animate__animated wow animate__fadeIn"
          v-for="(item, index) in trendsList"
          :key="index"
        >
          <a :href="item.link" target="_blank">
            <div class="pic"><img :src="item.pic" alt="" /></div>
            <div class="text">
              <h3>{{ item.title }}</h3>
              <p>{{ item.content }}</p>
            </div>
            <div class="shu"></div>
            <div class="time">
              <div class="day">{{ item.day }}</div>
              <div class="year">{{ item.year }}</div>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="page">
      <el-pagination
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next"
        :total="AlltrendsList.length"
        :page-size="5"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
// import WOW from "../../node_modules/wowjs/dist/wow";
import AllList from "@/assets/js/AlltrendsList.js";
export default {
  data() {
    return {
      // 页码
      pageInfo: {
        pageNum: 1,
        pageSize: 5,
      },
      // 当前页
      currentPage: 1,
      AlltrendsList: AllList,
      trendsList: [
        {
          pic: require("../assets/image/Trends/trends1.webp"),
          title:
            "Recently, the GYT completed financing to promote primary hemodialysis services, industrial expansion and information construction.",
          content:
            "Today, the GYT announced the completion of its Series A+ financing, led exclusively by Yunion Healthcare Ventures. BFC Group acted as the exclusive financial advisor to the financing.",
          year: "2022/01",
          day: "10",
          link: "https://mp.weixin.qq.com/s/6qUPtzpg_x0u9UpMbgcrHg",
        },
        {
          pic: require("../assets/image/Trends/trends2.webp"),
          title:
            'The Third Enrollment of the "National Hemodialysis Ability Training" program Hosted by the Capability Building and Continuing Education Center of the NHC Begins.',
          content:
            "Recently, the Capability Building and Continuing Education Center of the NHC released the notice of the third enrollment of the “National Hemodialysis Ability Training” program, which is hosted by the Center, and led by Professor Zuo Li, Director of the Department of Nephrology of the Peking University Peoples Hospital, jointly to build a national level...",
          year: "2021/06",
          day: "10",
          link: "https://mp.weixin.qq.com/s/i84dOvaWIMIvSY5ayBkbWg",
        },
        {
          pic: require("../assets/image/Trends/trends4.webp"),
          title: "The GYT Donates Necessary Supplies to Fight the Epidemic",
          content:
            "During the epidemic, the GYT donated vital signs monitoring equipments worth 3.01 million yuan to the Harbin government through the Red Cross on February 16, 2020...",
          year: "2020/12",
          day: "14",
          link: "https://mp.weixin.qq.com/s/FmnmF0Q8ckuFdPeMpBWgUg",
        },
        {
          pic: require("../assets/image/Trends/trends3.webp"),
          title:
            "The 4th National Science and Technology Workers' Day: Protecting kidney health — Delaying the progression of kidney disease and...",
          content:
            "Protect kidney health - delay the progression of kidney disease and choose dialysis mode series",
          year: "2020/05",
          day: "28",
          link: "https://mp.weixin.qq.com/s/KmyBM2RkWB5mJKBO0ZiWsQ",
        },

        // {
        //   pic: require('../assets/image/Trends/trends5.jpg'),
        //   title: '国医通（北京）科技发展有限公司与吉林正大国际医院合作的血...',
        //   content:
        //     '正大国际医院是正大制药集团投资的、以心脏内外诊疗为核心业务、开展常见病、多发病常规医疗服务、慢性病管理等现代新医学模式的小综合、大专科的高端现代化医疗服务机构。',
        //   year: '2018/05',
        //   day: '12',
        //   link: '#',
        // },
      ],
    };
  },
  created() {},
  mounted() {
    // let wow = new WOW.WOW({
    //   boxClass: "wow",
    //   animateClass: "animated",
    //   offset: 0,
    //   mobile: true,
    //   live: true,
    // });
    // wow.init();
  },
  methods: {
    // 按钮切换
    handleCurrentChange(val) {
      this.currentPage = val;
      // console.log(this.currentPage);
      if (val === 1) {
        this.trendsList = this.AlltrendsList.slice(0, 5);
        return;
      }
      let start = val * 5 - 5;
      let end = val * 5;
      const newList = this.AlltrendsList.slice(start, end);
      this.trendsList = newList;
    },
    // 箭头切换
    // uppage(val) {
    //   console.log(val);
    // },
    // nextpage(val) {
    //   console.log(val);
    // }
  },
};
</script>

<style scoped lang="scss">
.trends {
  .head {
    height: 5.2632rem;
    width: 100%;
    background: url("../assets/image/Trends/headimg.webp") no-repeat;
    background-size: 100% 100%;
    text-align: center;
    @media screen and (max-width: 540px) {
      height: 12.6316rem;
    }

    h3 {
      font-size: 0.4211rem;
      color: #ffffff;
      font-weight: 700;
      padding: 1.8947rem 0 0.5263rem 0;
      margin: 0;
      @media screen and (max-width: 540px) {
        padding: 4rem 0 1rem 0;
        font-size: 18px;
      }
    }
    p {
      color: #ffffff;
      font-weight: Normal;
      line-height: 0.5053rem;
      font-size: 0.2526rem;
      padding: 0 3rem;
      @media screen and (max-width: 540px) {
        font-size: 14px;
        line-height: 0.9474rem;
      }
    }
  }
  .content {
    padding: 1.0526rem 1.6842rem;
    @media screen and (max-width: 540px) {
      padding: 23px 15px;
    }
    ul {
      transition: all 0.5s;
      li {
        a {
          // display: block;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 2.8842rem;
          @media screen and (max-width: 540px) {
            height: 6.3158rem;
            padding: 15px 0;
            justify-content: space-between;
          }

          border-bottom: 1px solid #eeee;
          .pic {
            cursor: pointer;
            width: 2.6947rem;
            height: 1.9158rem;
            @media screen and (max-width: 540px) {
              height: 100%;
              width: 35%;
            }
            margin-right: 0.5263rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .text {
            width: 9.7895rem;
            @media screen and (max-width: 540px) {
              width: 50%;
            }
            h3 {
              color: #000000;
              font-size: 0.2737rem;
              margin: 0;
              padding-bottom: 0.4947rem;
              overflow: hidden; /*超出隐藏*/
              text-overflow: ellipsis; /*隐藏后添加省略号*/
              white-space: nowrap; /*强制不换行*/
              @media screen and (max-width: 540px) {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 16px;
              }
            }
            p {
              font-size: 0.2105rem;
              color: #334046;
              font-weight: 300;
              height: auto;
              display: -webkit-box;
              overflow: hidden; /*超出隐藏*/
              text-overflow: ellipsis; /*隐藏后添加省略号*/
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3; //想显示多少行
              @media screen and (max-width: 540px) {
                overflow: hidden;
                // white-space: nowrap;
                font-size: 12px;
                text-overflow: ellipsis;
                 -webkit-line-clamp: 4;
              }
            }
          }
          .shu {
            width: 0.0105rem;
            height: 1.1789rem;
            background-color: #707070;
            margin: 0 0.8421rem 0 1.0526rem;
            @media screen and (max-width: 540px) {
              display: none;
            }
          }
          .time {
            width: 1.2632rem;
            text-align: center;
            @media screen and (max-width: 540px) {
              width: 15%;
            }
            .day {
              color: #334046;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              font-size: 0.7158rem;
              padding-bottom: 0.0526rem;
              @media screen and (max-width: 540px) {
                font-size: 1.4737rem;
              }
            }
            .year {
              color: #999999;

              font-size: 0.2105rem;
              @media screen and (max-width: 540px) {
                font-size: 0.4211rem;
              }
            }
          }
        }
      }
    }
  }
  .page {
    // height: 0.4211rem;
    display: flex;
    justify-content: center;
    margin-bottom: 0.6316rem;
  }
}
</style>
